import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dashboard-card',
  templateUrl: './dashboard-card.component.html'
})
export class DashboardCardComponent implements OnInit {
  @Input() title: string;
  @Input() loading: boolean;

  constructor() { }

  ngOnInit() {
  }
}
